var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("hr"),
      _vm._v(" "),
      _vm.showManageVisitsResultsDetailPopup === false
        ? _c(
            "b-row",
            [
              _c("b-col", { attrs: { cols: 12 } }, [
                _c("h3", [_vm._v("Resultados")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "R/P = Realizada/Planificada | R/NP = Realizada/No planificada | P/NR = Planificada/No Realizada"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: 12 } }, [
                _c("div", { staticStyle: { "max-height": "50rem" } }, [
                  _c("table", { staticClass: "table custom" }, [
                    _c("thead", { attrs: { id: "head" } }, [
                      _c(
                        "tr",
                        [
                          _c("th", { staticClass: "big-col" }),
                          _vm._v(" "),
                          _c("th", { staticClass: "big-col-2" }),
                          _vm._v(" "),
                          _vm._l(_vm.weeksList, function(week) {
                            return _c(
                              "th",
                              {
                                staticClass: "text-center big-col",
                                attrs: { colspan: "4" }
                              },
                              [
                                _vm._v(
                                  "\n              Semana " +
                                    _vm._s(week.numWeek) +
                                    "\n              "
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      week.startWeekDay.format("DD/MM/YYYY")
                                    ) +
                                    " - " +
                                    _vm._s(
                                      week.endWeekDay.format("DD/MM/YYYY")
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass: "text-center big-col",
                              attrs: { colspan: "4" }
                            },
                            [_vm._v("Total gestor")]
                          )
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "tr",
                        [
                          _c("th", { staticClass: "big-col" }, [
                            _vm._v("Distribuidora")
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "big-col-2" }, [
                            _vm._v("Gestor")
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.weeksList, function(week) {
                            return [
                              _c("th", [_vm._v("R/P")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("R/NP")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("P/NR")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Total")])
                            ]
                          }),
                          _vm._v(" "),
                          _c("th", [_vm._v("R/P")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("R/NP")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("P/NR")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Total")])
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      { attrs: { id: "body" } },
                      [
                        _vm._l(
                          this.renderManagerRows(this.dataProcessed),
                          function(row) {
                            return [
                              row.type !== "total"
                                ? _c(
                                    "tr",
                                    [
                                      row.rowSpanDistributorCell > 0
                                        ? _c(
                                            "td",
                                            {
                                              staticClass:
                                                "zui-sticky-col big-col",
                                              attrs: {
                                                rowspan:
                                                  row.rowSpanDistributorCell
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(row.distributor) +
                                                  "\n              "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("td", { staticClass: "big-col-2" }, [
                                        _vm._v(_vm._s(row.manager))
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(_vm.weeksList, function(week) {
                                        return [
                                          _c("td", [
                                            _c(
                                              "a",
                                              {
                                                attrs: { href: "#" },
                                                on: {
                                                  click: function($event) {
                                                    _vm.goVisitsResultsDetail(
                                                      [row.distributor],
                                                      row.manager,
                                                      [week],
                                                      ["r_p"]
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.dataProcessed[
                                                        row.distributor
                                                      ][row.manager][week.year][
                                                        week.numWeek
                                                      ]["r_p"]
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c(
                                              "a",
                                              {
                                                attrs: { href: "#" },
                                                on: {
                                                  click: function($event) {
                                                    _vm.goVisitsResultsDetail(
                                                      [row.distributor],
                                                      row.manager,
                                                      [week],
                                                      ["r_np"]
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.dataProcessed[
                                                        row.distributor
                                                      ][row.manager][week.year][
                                                        week.numWeek
                                                      ]["r_np"]
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c(
                                              "a",
                                              {
                                                attrs: { href: "#" },
                                                on: {
                                                  click: function($event) {
                                                    _vm.goVisitsResultsDetail(
                                                      [row.distributor],
                                                      row.manager,
                                                      [week],
                                                      ["p_nr"]
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.dataProcessed[
                                                        row.distributor
                                                      ][row.manager][week.year][
                                                        week.numWeek
                                                      ]["p_nr"]
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", { staticClass: "total" }, [
                                            _c(
                                              "a",
                                              {
                                                attrs: { href: "#" },
                                                on: {
                                                  click: function($event) {
                                                    _vm.goVisitsResultsDetail(
                                                      [row.distributor],
                                                      row.manager,
                                                      [week],
                                                      ["r_p", "r_np", "p_nr"]
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.getManagerTotalVisitsPerWeek(
                                                        week,
                                                        row.distributor,
                                                        row.manager,
                                                        _vm.dataProcessed
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      }),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "a",
                                          {
                                            attrs: { href: "#" },
                                            on: {
                                              click: function($event) {
                                                _vm.goVisitsResultsDetail(
                                                  [row.distributor],
                                                  row.manager,
                                                  _vm.weeksList,
                                                  ["r_p"]
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.getManagerTotalVisits(
                                                    row.distributor,
                                                    row.manager,
                                                    _vm.dataProcessed,
                                                    ["r_p"]
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "a",
                                          {
                                            attrs: { href: "#" },
                                            on: {
                                              click: function($event) {
                                                _vm.goVisitsResultsDetail(
                                                  [row.distributor],
                                                  row.manager,
                                                  _vm.weeksList,
                                                  ["r_np"]
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.getManagerTotalVisits(
                                                    row.distributor,
                                                    row.manager,
                                                    _vm.dataProcessed,
                                                    ["r_np"]
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "a",
                                          {
                                            attrs: { href: "#" },
                                            on: {
                                              click: function($event) {
                                                _vm.goVisitsResultsDetail(
                                                  [row.distributor],
                                                  row.manager,
                                                  _vm.weeksList,
                                                  ["p_nr"]
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.getManagerTotalVisits(
                                                    row.distributor,
                                                    row.manager,
                                                    _vm.dataProcessed,
                                                    ["p_nr"]
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", { staticClass: "total" }, [
                                        _c(
                                          "a",
                                          {
                                            attrs: { href: "#" },
                                            on: {
                                              click: function($event) {
                                                _vm.goVisitsResultsDetail(
                                                  [row.distributor],
                                                  row.manager,
                                                  _vm.weeksList,
                                                  ["r_p", "r_np", "p_nr"]
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.getManagerTotalVisits(
                                                    row.distributor,
                                                    row.manager,
                                                    _vm.dataProcessed,
                                                    ["r_p", "r_np", "p_nr"]
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ])
                                    ],
                                    2
                                  )
                                : _c(
                                    "tr",
                                    { staticClass: "total" },
                                    [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "zui-sticky-col-3",
                                          attrs: { colspan: 2 }
                                        },
                                        [
                                          _vm._v(
                                            "TOTAL " + _vm._s(row.distributor)
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.weeksList, function(week) {
                                        return [
                                          _c("td", [
                                            _c(
                                              "a",
                                              {
                                                attrs: { href: "#" },
                                                on: {
                                                  click: function($event) {
                                                    _vm.goVisitsResultsDetail(
                                                      [row.distributor],
                                                      null,
                                                      [week],
                                                      ["r_p"]
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.getDistributorTotalVisitsPerWeek(
                                                        week,
                                                        row.distributor,
                                                        _vm.dataProcessed,
                                                        ["r_p"]
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c(
                                              "a",
                                              {
                                                attrs: { href: "#" },
                                                on: {
                                                  click: function($event) {
                                                    _vm.goVisitsResultsDetail(
                                                      [row.distributor],
                                                      null,
                                                      [week],
                                                      ["r_np"]
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.getDistributorTotalVisitsPerWeek(
                                                        week,
                                                        row.distributor,
                                                        _vm.dataProcessed,
                                                        ["r_np"]
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c(
                                              "a",
                                              {
                                                attrs: { href: "#" },
                                                on: {
                                                  click: function($event) {
                                                    _vm.goVisitsResultsDetail(
                                                      [row.distributor],
                                                      null,
                                                      [week],
                                                      ["p_nr"]
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.getDistributorTotalVisitsPerWeek(
                                                        week,
                                                        row.distributor,
                                                        _vm.dataProcessed,
                                                        ["p_nr"]
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c(
                                              "a",
                                              {
                                                attrs: { href: "#" },
                                                on: {
                                                  click: function($event) {
                                                    _vm.goVisitsResultsDetail(
                                                      [row.distributor],
                                                      null,
                                                      [week],
                                                      ["r_p", "r_np", "p_nr"]
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.getDistributorTotalVisitsPerWeek(
                                                        week,
                                                        row.distributor,
                                                        _vm.dataProcessed,
                                                        ["r_p", "r_np", "p_nr"]
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      }),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "a",
                                          {
                                            attrs: { href: "#" },
                                            on: {
                                              click: function($event) {
                                                _vm.goVisitsResultsDetail(
                                                  [row.distributor],
                                                  null,
                                                  _vm.weeksList,
                                                  ["r_p"]
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.getDistributorTotalVisits(
                                                    row.distributor,
                                                    _vm.dataProcessed,
                                                    ["r_p"]
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "a",
                                          {
                                            attrs: { href: "#" },
                                            on: {
                                              click: function($event) {
                                                _vm.goVisitsResultsDetail(
                                                  [row.distributor],
                                                  null,
                                                  _vm.weeksList,
                                                  ["r_np"]
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.getDistributorTotalVisits(
                                                    row.distributor,
                                                    _vm.dataProcessed,
                                                    ["r_np"]
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "a",
                                          {
                                            attrs: { href: "#" },
                                            on: {
                                              click: function($event) {
                                                _vm.goVisitsResultsDetail(
                                                  [row.distributor],
                                                  null,
                                                  _vm.weeksList,
                                                  ["p_nr"]
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.getDistributorTotalVisits(
                                                    row.distributor,
                                                    _vm.dataProcessed,
                                                    ["p_nr"]
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _c(
                                          "a",
                                          {
                                            attrs: { href: "#" },
                                            on: {
                                              click: function($event) {
                                                _vm.goVisitsResultsDetail(
                                                  [row.distributor],
                                                  null,
                                                  _vm.weeksList,
                                                  ["r_p", "r_np", "p_nr"]
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.getDistributorTotalVisits(
                                                    row.distributor,
                                                    _vm.dataProcessed,
                                                    ["r_p", "r_np", "p_nr"]
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ])
                                    ],
                                    2
                                  )
                            ]
                          }
                        ),
                        _vm._v(" "),
                        _c(
                          "tr",
                          { staticClass: "total" },
                          [
                            _c("td", { attrs: { colspan: 2 } }, [
                              _vm._v("TOTAL")
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.weeksList, function(week) {
                              return [
                                _c("td", [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          _vm.goVisitsResultsDetail(
                                            Object.keys(_vm.dataProcessed),
                                            null,
                                            [week],
                                            ["r_p"]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.getTotalVisitsPerWeek(
                                              week,
                                              _vm.dataProcessed,
                                              ["r_p"]
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          _vm.goVisitsResultsDetail(
                                            Object.keys(_vm.dataProcessed),
                                            null,
                                            [week],
                                            ["r_np"]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.getTotalVisitsPerWeek(
                                              week,
                                              _vm.dataProcessed,
                                              ["r_np"]
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          _vm.goVisitsResultsDetail(
                                            Object.keys(_vm.dataProcessed),
                                            null,
                                            [week],
                                            ["p_nr"]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.getTotalVisitsPerWeek(
                                              week,
                                              _vm.dataProcessed,
                                              ["p_nr"]
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          _vm.goVisitsResultsDetail(
                                            Object.keys(_vm.dataProcessed),
                                            null,
                                            [week],
                                            ["r_p", "r_np", "p_nr"]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.getTotalVisitsPerWeek(
                                              week,
                                              _vm.dataProcessed,
                                              ["r_p", "r_np", "p_nr"]
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ])
                              ]
                            }),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "a",
                                {
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      _vm.goVisitsResultsDetail(
                                        Object.keys(_vm.dataProcessed),
                                        null,
                                        _vm.weeksList,
                                        ["r_p"]
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.getTotalVisits(_vm.dataProcessed, [
                                          "r_p"
                                        ])
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "a",
                                {
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      _vm.goVisitsResultsDetail(
                                        Object.keys(_vm.dataProcessed),
                                        null,
                                        _vm.weeksList,
                                        ["r_np"]
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.getTotalVisits(_vm.dataProcessed, [
                                          "r_np"
                                        ])
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "a",
                                {
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      _vm.goVisitsResultsDetail(
                                        Object.keys(_vm.dataProcessed),
                                        null,
                                        _vm.weeksList,
                                        ["p_nr"]
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.getTotalVisits(_vm.dataProcessed, [
                                          "p_nr"
                                        ])
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "a",
                                {
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      _vm.goVisitsResultsDetail(
                                        Object.keys(_vm.dataProcessed),
                                        null,
                                        _vm.weeksList,
                                        ["r_p", "r_np", "p_nr"]
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.getTotalVisits(_vm.dataProcessed, [
                                          "r_p",
                                          "r_np",
                                          "p_nr"
                                        ])
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ])
                          ],
                          2
                        )
                      ],
                      2
                    )
                  ])
                ])
              ])
            ],
            1
          )
        : _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticStyle: { overflow: "auto", "max-height": "50rem" },
                  attrs: { cols: 12 }
                },
                [
                  _c("ManageVisitsResultsDetail", {
                    attrs: { searchCriteria: _vm.visitsResultDetailCriteria }
                  })
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Layout/CommercialManagement/ManageVisitsResults.vue?vue&type=template&id=01265c4c&scoped=true&
// module id = null
// module chunks = 